export default __webpack_public_path__ + "static/media/slide5.8f54c44a.jpg";